let dataLayer = window.dataLayer || [];

export const trackingEvent = ({
    event = 'Button Click',
    eventAction = '',
    eventLabel = ''
}) =>
    dataLayer.push({
        'event': event,
        'eventAction': eventAction,
        'eventLabel': eventLabel
    });
